import { Minus, Plus } from '@phosphor-icons/react'

import { uiTestId } from '../../test-ids/index'
import { IconButton } from '../button/icon-button'

export interface AmountPickerProps {
  value: number
  onChange: (n: number) => void
  decreaseDisabled?: boolean
  increaseDisabled?: boolean
  fixedValue?: number
  initialStep?: number
}

export function AmountPicker({
  value,
  onChange,
  decreaseDisabled = false,
  increaseDisabled = false,
  fixedValue,
  initialStep = 1,
}: AmountPickerProps) {
  const onIncrease = () => {
    // first increase should set the value to the initial step or fixed value if provided, otherwise increase by 1
    if (value === 0) {
      onChange(fixedValue || initialStep)
    } else {
      onChange(value + 1)
    }
  }

  const onDecrease = () => {
    // decrease to 0 if fixed value is provided or if the value is the initial step, otherwise decrease by 1
    if (fixedValue || value === initialStep) {
      onChange(0)
    } else {
      onChange(value - 1)
    }
  }
  return (
    <div className="relative flex items-center space-x-1">
      <IconButton
        variant="blue"
        disabled={decreaseDisabled}
        onClick={onDecrease}
        Icon={Minus}
        data-testid={uiTestId('AmountPicker.decrease')}
        aria-label="entfernen"
      />
      <div
        className="flex size-10 items-center justify-center font-body-copy font-semibold"
        data-testid={uiTestId('AmountPicker.value')}
      >
        {value}
      </div>
      <IconButton
        variant="blue"
        onClick={onIncrease}
        disabled={increaseDisabled}
        Icon={Plus}
        data-testid={uiTestId('AmountPicker.increase')}
        aria-label="hinzufügen"
      />
    </div>
  )
}
